export default {
  buttonText: 'Contact Support',
};
